import React from 'react';
import { CCOrganization } from '../../types';
import { OrgConfigurationForm } from './OrgConfigurationForm';
export interface OrgConfigurationPanelProps {
    organization: CCOrganization;
    onSaved: () => void;
}
/**
 * Inline "Org Configuration" destination — renders the organization
 * configuration form. Org Admins is now a separate primary-sidebar section
 * (see OrgDetailSidebar / OrganizationDetailView), so this panel no longer
 * wraps its peers in a tab shell.
 */ export const OrgConfigurationPanel: React.FC<OrgConfigurationPanelProps> = ({ organization, onSaved })=>(<div className={" sd171 _ta171 Ul171 ql171 JC171"}>
    <OrgConfigurationForm organization={organization} onSaved={onSaved}/>
  </div>);
export default OrgConfigurationPanel;

import "macro-3498e4b971c2848dd0bf5ed698fdd4332fc67357ba07fff4c70cbf214fc7fc6c.css";